import { createPersistedState } from "@caiji-games/shared-state";

export const persistedState = createPersistedState("minesweeper:");
